import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ReturnStruct } from 'src/app/shared/structs/return.struct';
import { environment } from 'src/environments/environment';
import { CommonService } from '../../common-service';
import { MedicFavoriteExternalPrescriptionRequest } from '../../requests/medic/medic-favorite-external-prescription.request';
import { MedicFavoriteExternalPrescriptionResponse } from '../../responses/medic/medic-favorite-external-prescription.response';

@Injectable({
  providedIn: 'root'
})
export class MedicFavoriteExternalPrescriptionService extends CommonService {

  constructor(private router: Router, private httpClient: HttpClient) {
    super();
  }

  public listMedicFavoriteExternalPrescription(): Observable<MedicFavoriteExternalPrescriptionResponse> {
    let uri = `MedicFavoriteExternalPrescription`;

    return this.httpClient.get<MedicFavoriteExternalPrescriptionResponse>(environment.urlApiMedic + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public deleteMedicFavoriteExternalPrescription(idMedicFavoriteExternalPrescription: number): Observable<ReturnStruct> {
    let uri = `MedicFavoriteExternalPrescription/idMedicFavoriteExternalPrescription/${idMedicFavoriteExternalPrescription}`;

    return this.httpClient.delete<ReturnStruct>(environment.urlApiMedic + uri, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public createMedicFavoriteExternalPrescription(request: MedicFavoriteExternalPrescriptionRequest): Observable<ReturnStruct> {
    let uri = `MedicFavoriteExternalPrescription`;

    return this.httpClient.post<ReturnStruct>(environment.urlApiMedic + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public updateMedicFavoriteExternalPrescription(request: MedicFavoriteExternalPrescriptionRequest): Observable<ReturnStruct> {
    let uri = `MedicFavoriteExternalPrescription`;

    return this.httpClient.put<ReturnStruct>(environment.urlApiMedic + uri, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}